import React from 'react';
import PropTypes from 'prop-types';
import onClickOutside from 'react-onclickoutside';
import { ColorPicker } from '@bingads-webui-react/fabric-control';

class ColorPickerClickWrapper extends React.PureComponent {
  handleClickOutside = this.props.hideColorPicker

  render() {
    return (<ColorPicker {...this.props} />);
  }
}

ColorPickerClickWrapper.propTypes = {
  hideColorPicker: PropTypes.func.isRequired,
};

export const ColorPickerWithClickOutside = onClickOutside(ColorPickerClickWrapper);
